<template>
    <div class="pad-admin-company">
      <div class="nav">
        <div class="title" @click="$router.replace({ path: '/' });">创建档案</div>
      </div>
      <div class="content">
        <div class="left">
          <div class="left-item" :class="{ active: active == 'info' }">
            <div class="left-item-icon icon-1"></div>
            <div class="left-item-title">基本信息</div>
          </div>
          <div class="left-item" :class="{ active: active == 'services' || active == 'sign' }">
            <div class="left-item-icon icon-2"></div>
            <div class="left-item-title">服务内容</div>
          </div>
        </div>
        <div class="right">
            <div class="right-title">服务内容</div>
            <div class="right-content" v-if="active == 'services'">
                <div class="service-list">
                    <div v-for="(item, index) in serviceList" :key="index" class="service-item">{{ (index + 1) + '、' + item.content }}</div>
                </div>
            </div>

            <div class="right-content" v-if="active == 'info'">
                <div class="right-content-item">
                    <div class="right-content-item-title">姓名：</div>
                    <div class="right-content-item-content">
                        <input type="text" v-model="person.name" placeholder="请输入姓名"></input>
                    </div>
                </div>
                <div class="right-content-item">
                    <div class="right-content-item-title">手机号：</div>
                    <div class="right-content-item-content">
                        <input type="text" v-model="person.mobile" placeholder="请输入手机号"></input>
                    </div>
                </div>
                <div class="right-content-item">
                    <div class="right-content-item-title">身份证号：</div>
                    <div class="right-content-item-content">
                        <input type="text" v-model="person.idCard" placeholder="请输入身份证号"></input>
                    </div>
                </div>
            </div>

            <div class="right-content" v-if="active == 'sign'">
                <div class="esign-view">
                    <div class="esign-btn">
                        <div class="btn" @click="handleReset">重写</div>
                        <div class="btn" @click="handleGenerate" v-if="!isCheck">确认</div>
                    </div>
                    <div class="esign-canvas">
                      <vue-esign ref="esign" :width="remToPx(5.66)" :height="remToPx(1.51)" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor" />
                    </div>
                    <div class="tips">请手写签字，笔画完成</div>
                </div>
            </div>

            <div class="step-control">
                <div class="btn btn-1" @click="prve()">{{ active == 'info' ? '取消' : '上一步' }}</div>
                <div class="btn btn-2" @click="next()">{{ active == 'sign' ? '提交' : '下一步' }}</div>
            </div>

        </div>
      </div>
    </div>
  </template>

  <script>
  import { getCompanyServices, createCompanyPerson } from "@api/index";

  export default {
    name: 'pad-admin-company',
    data() {
      return {
        person : {
          idCard : '',
          mobile : '',
          name : '',
        },
        isCheck : false,
        width : 800,
        height : 400,
        lineWidth: 6,
        lineColor: '#000000',
        bgColor: '#ffffff00',
        resultImg: '',
        isCrop: true,
        active: 'info',
        serviceList : []
      }
    },
    methods: {
      prve() {
        if (this.active == 'info') {
          this.$router.replace({ path: '/' });
        } else if (this.active == 'sign') {
          this.$refs.esign.reset()
          this.isCheck = false
          this.resultImg = ''
          this.active = 'services'
        } else if (this.active == 'services') {
          this.active = 'info'
        }
      },
      next() {
        let that = this;
        const phoneRegex = /^1[3-9]\d{9}$/;
        const idCardRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}[\dXx]$)/;
        if (this.active == 'info') {
          if (!this.person.name) return this.$dialog.toast({ mes: "请填写姓名" });
          if (!this.person.mobile || !phoneRegex.test(this.person.mobile)) return this.$dialog.toast({ mes: "请填写有效手机号" });
          if (!this.person.idCard || !idCardRegex.test(this.person.idCard)) return this.$dialog.toast({ mes: "请填写有效身份证号码" });
          getCompanyServices().then(res => {
            that.serviceList = res.data;
            that.active = 'services';
          }).catch(err => {
            return this.$dialog.toast({ mes: err.msg || '请求异常' });
          });
        } else if (this.active == 'services') {
          this.active = 'sign';
        } else if (this.active == 'sign') {
          if (!this.resultImg) return this.$dialog.toast({ mes: "请签名" });
          this.submit();
        }
      },
      submit() {
        let that = this;
        let post = this.person;
        post.esign = this.resultImg;
        createCompanyPerson(post).then(res => {
          that.$dialog.toast({ mes: '注册成功' });
          setTimeout(() => {
            that.$router.replace({ path: '/' });
          }, 1000);
        }).catch(err => {
          return that.$dialog.toast({ mes: err.msg || '请求异常' });
        });
      },
      handleReset () {
        this.isCheck = false;
        this.$refs.esign.reset()
      },
      handleGenerate () {
        this.$refs.esign.generate().then(res => {
          this.resultImg = res
          this.isCheck = true;
        }).catch(err => {
          return this.$dialog.toast({ mes: "请签名" });
        })
      },
      selectContent(type) {
        this.active = type
      },
      goPage(page) {
        if (page == '/padAdmin/shop') return this.$dialog.toast({ mes: "暂未开放" });
        this.$router.push({
          path: page
        })
      },
      remToPx(rem) {
        const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        console.log(rootFontSize)
        return rem * rootFontSize;
        }
    },
    mounted() {
    }
  }
  </script>

  <style scoped  lang="scss">
  .pad-admin-company {

    .nav {
      font-family: 'YouSheBiaoTiHei';
      color: #FFFFFF;
      font-weight: 400;
      font-size: 48px;
      margin-top: 143px;
      margin-left: 30px;
      position: relative;

      .title {
        display: inline-block;
        padding: 0 44px 0;
      }



      &::before {
        content: '';
        width: 25px;
        height: 25px;
        border-top: 4px solid transparent;
        border-bottom: 4px solid #fff;
        border-right: 4px solid transparent;
        border-left: 4px solid #fff;
        ;
        /* 箭头的颜色 */
        position: absolute;
        /* 设置绝对定位 */
        top: 50%;
        left: 0%;
        transform: rotate(45deg) translateY(-50%);
      }
    }

    .content {
      display: flex;
      margin-top: 48px;

      .left {
        background: linear-gradient(180deg, #0066cc, transparent);
        width: 400px;
        height: 768px;
        border-radius: 0rem 20px 20px 20px;
        opacity: 0.9;
        display: flex;
        flex-wrap: wrap;
        align-content: center;


        .left-item {
          width: 100%;
          height: 108px;
          font-weight: 600;
          font-size: 30px;
          color: #FFFFFF;
          line-height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 84px;

          .left-item-icon {
            width: 29px;
            height: 29px;
            background-size: 100%;

            &.icon-1 {
              background-image: url("../../assets/images/left-icon-1.png");
            }

            &.icon-2 {
              background-image: url("../../assets/images/left-icon-2.png");
            }

            &.icon-3 {
              background-image: url("../../assets/images/left-icon-3.png");
            }

            &.icon-4 {
              background-image: url("../../assets/images/left-icon-4.png");
            }

          }

          .left-item-title {
            margin-left: 19px;
          }

          &.active {
            background: #1FA4EB;
            border-radius: 0rem 20px 20px 0rem;
          }
        }
      }

      .right {
        background: linear-gradient(180deg, #0066cc, transparent);
        flex: 1;
        margin: 0 40px;
        height: 768px;
        border-radius: 20px;
        position: relative;

        .right-title {
            font-weight: 600;
            font-size: 36px;
            color: #FFFFFF;
            line-height: 116px;
            height: 116px;
            text-align: center;
            border-bottom: 1px solid #1FA4EB;
        }

        .right-content {
            padding-top: 29px;


            .service-list {
                width: 1100px;
                height: 480px;
                margin: 0 auto;
                overflow: scroll;

                .service-item {
                    font-weight: 400;
                    font-size: 26px;
                    color: #FFFFFF;
                    line-height: 44px;

                    &:first-child {
                        margin-top: 32px;
                    }
                }
            }

            .esign-view {
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;

                .esign-canvas {
                  background-color: #FFFFFF;
                  border-radius: 20px;
                }

                canvas {
                  border-radius: 20px;
                }

                .tips {
                    margin-top: 30px;
                    font-weight: 400;
                    font-size: 26px;
                    color: #FFFFFF;
                    line-height: 44px;
                }
            }


            .right-content-item {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 50px;

                .right-content-item-title {
                    font-weight: 500;
                    font-size: 28px;
                    color: #FFFFFF;
                    line-height: 36px;
                    width: 160px;
                    text-align: right;
                    margin-right: 20px;
                    position: relative;

                    &::before {
                        content: '*';
                        position: absolute;
                        top: 0;
                        transform: translateX(-20px);
                        color: red;
                    }
                }


                .right-content-item-content {
                    width: 560px;
                    height: 80px;
                    input {
                        display: block;
                        width: inherit;
                        height: inherit;
                        padding: 24px;
                        color: #fff;
                        font-size: 26px;
                        background: #033172e6;
                        border-radius: 20px;
                    }
                }



            }
        }

        .step-control {
            position: absolute;
            bottom: 74px;
            text-align: center;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            .btn {
                text-align: center;
                width: 180px;
                height: 80px;
                border-radius: 20px;
                opacity: 0.9;
                font-weight: 500;
                font-size: 30px;
                color: #FFFFFF;
                line-height: 80px;
                display: inline-block;
                margin: 0 100px;
                &.btn-1 {background: #013A82;}
                &.btn-2 {background: #1FA4EB;}
            }
        }
      }
    }

    .esign-btn {
      display: flex;
      margin-bottom: 29px;

      .btn {
        background-color: #1FA4EB;
        text-align: center;
        width: 120px;
        height: 60px;
        border-radius: 20px;
        opacity: 0.9;
        font-weight: 500;
        font-size: 24px;
        color: #FFFFFF;
        line-height: 60px;
        display: inline-block;
        margin: 0 100px;
      }
    }
  }
  </style>
